<nav class="bg-primary-900">
  <div class="app__container">
    <div class="relative flex h-16 items-center justify-between text-white">
      <div><strong>activar</strong> - Link de pago</div>
    </div>
  </div>
</nav>
<div class="app__container pb-20">
  <router-outlet />
</div>
